export const SET_BRG_DISCHARGED_PATIENTS = 'SET_BRG_DISCHARGED_PATIENTS';
export const SET_EMAIL_PROMPT = 'SET_EMAIL_PROMPT';
export const SET_EMAIL_PROMPT_ONLY = 'SET_EMAIL_PROMPT_ONLY';
export const SET_GENERATED_EMAIL = 'SET_GENERATED_EMAIL';
export const SET_FILTERED_EMAIL = 'SET_FILTERED_EMAIL';
export const SET_PT_SUMM_PROMPT = 'SET_PT_SUMM_PROMPT';
export const SET_PT_SUMM_PROMPT_ONLY = 'SET_PT_SUMM_PROMPT_ONLY';
export const SET_PROMPT = 'SET_PROMPT';

export const SET_BRG_PATIENT_EMAIL_LOGS = 'SET_BRG_PATIENT_EMAIL_LOGS';
